// Location-plan ("Positionsplan") model helpers — pure JS (no DOM), safe to use
// from the canvas and (potentially) tests. A location page overlays device
// markers + their connections onto a physical background image.
import { findDeviceGlobal, getAllEdges } from './detail';
import { deviceLabel } from './deviceIcons';

// Marker icon box size (logical px) — kept in sync with the SVG/drawio exporters.
export const MARKER_SIZE = 46;

// Derive the renderable model for a location page:
// { markers:[{deviceId, node, position}], edges:[{id, source, target, connType}] }
export function computeLocationModel(doc, page) {
  const markers = (page.markers || [])
    .map((m) => {
      const node = findDeviceGlobal(doc, m.deviceId);
      if (!node) return null;
      return { deviceId: m.deviceId, node, position: m.position || { x: 0, y: 0 } };
    })
    .filter(Boolean);
  const set = new Set(markers.map((m) => m.deviceId));
  const edges = [];
  getAllEdges(doc).forEach((e) => {
    if (set.has(e.source) && set.has(e.target)) {
      edges.push({
        id: e.id,
        source: e.source,
        target: e.target,
        connType: e.connType || 'ethernet',
        sourcePortId: e.sourcePortId || null,
        targetPortId: e.targetPortId || null,
      });
    }
  });
  return { markers, edges };
}

export function markerLabel(node, lang = 'de') {
  return node?.data?.label || deviceLabel(node?.data?.deviceType, lang);
}
